'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';

const ACCESSIBILITY_WIDGET_SCRIPT = {
  src: 'https://accessibilityserver.org/widget.js',
  strategy: 'lazyOnload' as const,
  'data-account': 'jcEETxr6Cv',
};

export function ConditionalUserWayScripts() {
  const pathname = usePathname();

  const disabledPages = ['shop', 'product'];
  const pathSegments = pathname.split('/').filter(Boolean);

  const shouldLoadAccessibilityWidget = !disabledPages.some((page) => pathSegments.includes(page));

  return <>{shouldLoadAccessibilityWidget && <Script {...ACCESSIBILITY_WIDGET_SCRIPT} />}</>;
}
